// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"No-z","breadcrumbForward":"Oo-z","breadcrumbBack":"Po-z","selected":"Qo-z"};